import React from 'react';
import { Box, Typography, Container, Button, Paper, Divider } from '@mui/material';
import { InfoOutlined, ContactSupport } from '@mui/icons-material';

const UnregisteredUser = ({ email }) => {
  // Function to handle the contact admin action
  const handleContactAdmin = () => {
    // Extract the domain from the email
    const domain = email.split('@')[1];
    
    // Assume IT support email format
    const supportEmail = `finance@aderbid.com`;
    
    // Create email with pre-filled subject and body
    const subject = encodeURIComponent('Request for Aderbid Cloud Platform Access');
    const body = encodeURIComponent(
      `Hello,\n\nI'm trying to access the Aderbid Cloud platform with my account (${email}) but I'm not registered in the system.\n\nCould you please help me get access?\n\nThank you.`
    );
    
    // Open the default email client
    window.location.href = `mailto:${supportEmail}?subject=${subject}&body=${body}`;
  };

  return (
    <Container maxWidth="md">
      <Paper 
        elevation={3}
        sx={{
          marginTop: 8,
          p: 4,
          borderRadius: 2,
          borderTop: '4px solid #3f51b5'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 2
          }}
        >
          <InfoOutlined sx={{ fontSize: 60, color: '#3f51b5', mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom>
            Account Not Registered
          </Typography>
          
          <Typography variant="body1" paragraph>
            The email address <strong>{email}</strong> is authenticated but not registered in our platform.
          </Typography>
          
          <Divider sx={{ width: '100%', my: 2 }} />
          
          <Typography variant="body1" paragraph>
            You need to be registered by an administrator to access the Aderbid Cloud platform.
          </Typography>
          
          <Typography variant="body2" color="text.secondary" paragraph>
            If you believe this is an error or need access to the platform, please contact your system administrator.
          </Typography>
          
          <Button 
            variant="contained" 
            color="primary" 
            startIcon={<ContactSupport />}
            onClick={handleContactAdmin}
            sx={{ mt: 2 }}
          >
            Contact Administrator
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default UnregisteredUser; 